import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { WHATSAPP_NUMBERS, WHATSAPP_COMMUNITY_LINK, INSTAGRAM_LINK } from "@/lib/whatsapp";
import { scrollToId } from "@/lib/scroll";

const NAV_LINKS = [
  { id: "home", label: "Home", type: "scroll" },
  { id: "gold", label: "Gold", type: "page", to: "/all-items?category=gold" },
  { id: "silver", label: "Silver", type: "page", to: "/all-items?category=silver" },
  { id: "others", label: "Others", type: "page", to: "/all-items?category=others" },
  { id: "offers", label: "Offers", type: "page", to: "/new-arrivals" },
  { id: "festival", label: "Festival", type: "page", to: "/new-arrivals" },
  { id: "enquire", label: "Enquire", type: "scroll" },
];

export const Footer = () => {
  const navigate = useNavigate();

  return (
  <footer className="relative bg-background border-t border-border pt-16 pb-8 overflow-hidden">
    <div
      className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full pointer-events-none opacity-40"
      style={{ background: "var(--gradient-radial-glow)" }}
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/images/jewellery/logo.png"
              alt="Vini Gems And Jewellers logo"
              className="h-14 w-14 object-contain rounded-full ring-1 ring-primary/40"
            />
            <div className="flex flex-col leading-none">
              <span className="font-heading text-xl font-semibold text-foreground">Vini Gems</span>
              <span className="text-[10px] uppercase tracking-[0.25em] text-primary mt-1">And Jewellers</span>
            </div>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Gold, silver &amp; fine jewellery — browse our collection and connect with us directly on
            WhatsApp.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground uppercase tracking-wide mb-4">
            Quick Links
          </h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => (l.type === "page" ? navigate(l.to) : scrollToId(l.id))}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <Link to="/new-arrivals" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                New Arrivals
              </Link>
            </li>
            <li>
              <Link to="/all-items" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                All Items
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground uppercase tracking-wide mb-4">
            WhatsApp Contacts
          </h4>
          <ul className="space-y-2.5">
            {WHATSAPP_NUMBERS.map((wa) => (
              <li key={wa.number} className="text-sm text-muted-foreground flex items-center gap-2">
                <i className="fa-brands fa-whatsapp text-primary" /> {wa.label}
                {wa.active && <span className="text-[10px] text-whatsapp font-medium">(Always Active)</span>}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground uppercase tracking-wide mb-4">
            Follow Us
          </h4>
          <div className="flex items-center gap-3">
            <a
              href={WHATSAPP_COMMUNITY_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="h-11 w-11 rounded-full bg-card border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-colors duration-300"
              aria-label="WhatsApp Community"
            >
              <i className="fa-brands fa-whatsapp text-lg" />
            </a>
            <a
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="h-11 w-11 rounded-full bg-card border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-colors duration-300"
              aria-label="Instagram"
            >
              <i className="fa-brands fa-instagram text-lg" />
            </a>
          </div>
        </div>
      </div>

      <div className="divider-gold mt-12 mb-6" />
      <p className="text-center text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} Vini Gems And Jewellers. All rights reserved.
        {" "}
        <a href="/admin/login" className="text-muted-foreground/60 hover:text-primary transition-colors duration-300">
          Admin
        </a>
      </p>
    </div>
  </footer>
  );
};
